import React from 'react';
import { Calendar } from 'react-feather';
import { useMasterData } from '../../utils/useMasterData';

const EventPanel = ({ panelRef }) => {
    const { items: eventTypes = [], loading } = useMasterData('calendarEventType');

    return (
        <div className="event-panel">
            <div className="event-panel-header">
                <div className="event-panel-title">
                    <Calendar size={16} style={{ marginRight: '6px' }} />
                    Event Types
                </div>
            </div>

            <div className="event-panel-body" ref={panelRef}>
                {loading ? (
                    <p className="text-muted small mb-0">Loading event types...</p>
                ) : eventTypes.length === 0 ? (
                    <p className="text-muted small mb-0">No event types available.</p>
                ) : (
                    <div className="event-list-items">
                        {eventTypes.map((eventType) => (
                            <div
                                key={eventType.MasterValueId}
                                className="event-item"
                                data-event-type-id={eventType.MasterValueId}
                                data-event-name={eventType.DisplayName}
                            >
                                <div className="event-item-title">{eventType.DisplayName}</div>
                                {eventType.Description ? (
                                    <div className="event-item-description">{eventType.Description}</div>
                                ) : null}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default EventPanel;
